import script from "./check-account.vue?vue&type=script&setup=true&lang=js"
export * from "./check-account.vue?vue&type=script&setup=true&lang=js"

import "./check-account.vue?vue&type=style&index=0&id=70b24794&lang=scss&scoped=true&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b24794"]])

export default __exports__